import { Stack } from '@mui/material';
import ProductBreakdown from 'src/features/CompanyTradeData/HSCode/ProductBreakdown';
import Top10HSCode from 'src/features/CompanyTradeData/HSCode/Top10HSCode';

const HSCode = () => {
  return (
    <Stack spacing={3}>
      <ProductBreakdown />
      <Top10HSCode />
    </Stack>
  );
};

export default HSCode;
